<template>
    <div class="card">
        <div class="card-content">
            <p class="title">Detalle de Llamada<span><li class="icon fa fa-phone"
                                                         style="font-size: 30px;margin:10px"></li></span><span
                    style="font-size: 30px;margin:10px"></span></p>

            <p class="title is-4">Número entrante: {{item.from}}</p>
            <p class="title is-4">Número de operadora: {{item.to}}</p>
            <div class="content">
                Atendio: <strong>{{item.name}}</strong>
                <br>
                Fecha de llamada: <strong>{{ item.created_at| date}}</strong>
                <br>
                Inicio: <strong>{{item.attended_at|time}}</strong>
                <br>
                Fin: <strong>{{item.finished_at|time}}</strong>
                <br>
                Duración: <strong>{{item.answered_poll_at|Duration(item.finished_at)}}</strong>
                <b-field label="Comentario">
                    <b-input v-model="item.comments" disabled maxlength="200" type="textarea"></b-input>
                </b-field>
                <strong>Grabaciones</strong>
                <div v-for="record in item.records">
                    <audio controls>
                        <source :src="record.record_url" >
                        Your browser does not support the audio element.
                    </audio>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Show",
        props: {
            modalActive: {
                default: false
            },
            item: {}
        }
    }
</script>

<style scoped>

</style>

